import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import {history} from '/app/src/store';
import {connect} from 'react-redux';

//Socket
import {destroySocket} from '/app/src/store/socket'

//Models
import UserModel from '/app/src/model/User/model';

class ProfileItem extends React.Component {
    constructor(props)
    {
        super(props);

        this._handleItemClick = this._handleItemClick.bind(this);
    }

    _handleItemClick(){
        this.props.onClickCloseModal('profileDisplay');
        if(this.props.url) history.push({pathname: this.props.url});
        if(this.props.logOut){
            this.props.dispatch(UserModel.logout());
            destroySocket();
        }


    }

    render() {
        const imgSrc = this.props.imgSrc;
        const text = this.props.text;

        return (
            <Flex onClick={this._handleItemClick} className={style.profileItemWrapper} padding='10px 20px 10px 20px' mr='0px !important' bb='2px solid lightgrey'>
            <img alt='' className={style.icon} src={imgSrc}/>
                <Flex onClick={this._handleItemClick} va='center' ml='10px' className={style.textWrapper}>
                    {text}
                </Flex>
            </Flex>
        )
    }
}



export default connect(null)(ProfileItem);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/ProfileDisplay/ProfileItem/index.js